var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_1",
    "data-name": "share 1",
    transform: "translate(0 -1.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5256",
    "data-name": "Path 5256",
    d: "M15.454,5.56,11.832,1.774a1.283,1.283,0,0,0-.9-.471c-.411,0-.89.326-.89,1.246V3.838A10.23,10.23,0,0,0,3.079,7.045,11.17,11.17,0,0,0,0,14.813a.489.489,0,0,0,.32.465.45.45,0,0,0,.148.025.462.462,0,0,0,.375-.2,11.84,11.84,0,0,1,9.2-5.043v1.269c0,.92.479,1.246.89,1.246h0a1.283,1.283,0,0,0,.9-.471l3.622-3.786a2.022,2.022,0,0,0,0-2.763Z",
    fill: "#71207c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share-link.d2acec68f627345683bae5f4c554c63a.svg";
export { ForwardRef as ReactComponent };